/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 18.09.25
 *
 */
import {DueDateTypeEnum} from "@shared/Todo/DueDateTypeEnum";


const TodoGroupEnum = Object.freeze({
	CUSTOM: 'CUSTOM',
	ADMIN: 'ADMIN',
	PARENT: 'PARENT',
	BASELINE_ASSESSMENT: 'BASELINE_ASSESSMENT',
	CODING: 'CODING',
	BIRTH: 'BIRTH',
	TLSW: 'TLSW'
});

const TlswTodoTypeEnum = Object.freeze({
	CUSTOM: 'CUSTOM',
	ADMIN_ORDER_FORM_SIGNED: 'ADMIN_ORDER_FORM_SIGNED',
	ADMIN_INTERIM_REPORT: 'ADMIN_INTERIM_REPORT',
	ADMIN_TOP_UP_BID: 'ADMIN_TOP_UP_BID',
	ADMIN_FINAL_REPORT: 'ADMIN_FINAL_REPORT',
	ADMIN_ALL_PAPERWORK_DESTROYED: 'ADMIN_ALL_PAPERWORK_DESTROYED',
	ADMIN_FOLLOW_UP_WORK_COMPLETED: 'ADMIN_FOLLOW_UP_WORK_COMPLETED',

	PARENT_ABOUT_TLSW_GIVEN: 'PARENT_ABOUT_TLSW_GIVEN',
	PARENT_SCOPE_CONSENT_SIGNED: 'PARENT_SCOPE_CONSENT_SIGNED',
	PARENT_DATA_POLICY_GIVEN: 'PARENT_DATA_POLICY_GIVEN',
	PARENT_DATA_POLICY_SIGNED: 'PARENT_DATA_POLICY_SIGNED',
	PARENT_BIRTH_WORK_CONSENT_SIGNED: 'PARENT_BIRTH_WORK_CONSENT_SIGNED',

	BASELINE_ASSESSMENT_INITIAL_COMPLETED: 'BASELINE_ASSESSMENT_INITIAL_COMPLETED',
	BASELINE_ASSESSMENT_INITIAL_UPLOADED: 'BASELINE_ASSESSMENT_INITIAL_UPLOADED',
	BASELINE_ASSESSMENT_FINAL_COMPLETED: 'BASELINE_ASSESSMENT_FINAL_COMPLETED',
	BASELINE_ASSESSMENT_FINAL_UPLOADED: 'BASELINE_ASSESSMENT_FINAL_UPLOADED',

	CODING_LOCATION_IDENTIFIED: 'CODING_LOCATION_IDENTIFIED',
	CODING_HOLDER_IDENTIFIED: 'CODING_HOLDER_IDENTIFIED',
	CODING_FILES_OBTAINED: 'CODING_FILES_OBTAINED',
	CODING_COMPLETED: 'CODING_COMPLETED',

	BIRTH_LETTERBOX_CONTACTED: 'BIRTH_LETTERBOX_CONTACTED',

	BIRTH1_IDENTIFIED: 'BIRTH1_IDENTIFIED',
	BIRTH1_CONTACTED: 'BIRTH1_CONTACTED',
	BIRTH1_VISIT_DATE_ARRANGED: 'BIRTH1_VISIT_DATE_ARRANGED',
	BIRTH1_LOCATION_IDENTIFIED: 'BIRTH1_LOCATION_IDENTIFIED',
	BIRTH1_LOCATION_BOOKED: 'BIRTH1_LOCATION_BOOKED',
	BIRTH1_VISIT_COMPLETED: 'BIRTH1_VISIT_COMPLETED',
	BIRTH1_TRANSCRIBED: 'BIRTH1_TRANSCRIBED',

	BIRTH2_IDENTIFIED: 'BIRTH2_IDENTIFIED',
	BIRTH2_CONTACTED: 'BIRTH2_CONTACTED',
	BIRTH2_VISIT_DATE_ARRANGED: 'BIRTH2_VISIT_DATE_ARRANGED',
	BIRTH2_LOCATION_IDENTIFIED: 'BIRTH2_LOCATION_IDENTIFIED',
	BIRTH2_LOCATION_BOOKED: 'BIRTH2_LOCATION_BOOKED',
	BIRTH2_VISIT_COMPLETED: 'BIRTH2_VISIT_COMPLETED',
	BIRTH2_TRANSCRIBED: 'BIRTH2_TRANSCRIBED',

	TLSW_ALL_ABOUT_ME: 'TLSW_ALL_ABOUT_ME',
	TLSW_DRAFT_COMPLETED: 'TLSW_DRAFT_COMPLETED',
	TLSW_DRAFT_PRESENTED: 'TLSW_DRAFT_PRESENTED',
	TLSW_FINAL_COMPLETED: 'TLSW_FINAL_COMPLETED',
	TLSW_FINAL_PRINTED: 'TLSW_FINAL_PRINTED',
	TLSW_FINAL_LOADED: 'TLSW_FINAL_LOADED',
	TLSW_BOOK_DELIVERED: 'TLSW_BOOK_DELIVERED',
});


const TlswTodoTemplate = {
	entries: [
		{ type: TlswTodoTypeEnum.ADMIN_ORDER_FORM_SIGNED, title: 'Sign Order Form', group: TodoGroupEnum.ADMIN, sortOrder: 1000 },
		{ type: TlswTodoTypeEnum.ADMIN_INTERIM_REPORT, title: 'Complete Interim Report', group: TodoGroupEnum.ADMIN, sortOrder: 2000 },
		{ type: TlswTodoTypeEnum.ADMIN_TOP_UP_BID, title: 'Submit Top-up Bid', group: TodoGroupEnum.ADMIN, sortOrder: 3000 },
		{ type: TlswTodoTypeEnum.ADMIN_FINAL_REPORT, title: 'Complete Final Report', group: TodoGroupEnum.ADMIN, dueDateType: DueDateTypeEnum.END_OF_CONTRACT, sortOrder: 4000 },
		{ type: TlswTodoTypeEnum.ADMIN_ALL_PAPERWORK_DESTROYED, title: 'Destroy/Return All Paperwork', group: TodoGroupEnum.ADMIN, dueDateType: DueDateTypeEnum.END_OF_CONTRACT, sortOrder: 5000 },
		{ type: TlswTodoTypeEnum.ADMIN_FOLLOW_UP_WORK_COMPLETED, title: 'Complete Follow-up Work', group: TodoGroupEnum.ADMIN, dueDateType: DueDateTypeEnum.END_OF_CONTRACT, sortOrder: 6000 },

		{ type: TlswTodoTypeEnum.PARENT_ABOUT_TLSW_GIVEN, title: 'Give "About TLSW" Information', group: TodoGroupEnum.PARENT, dueDateType: DueDateTypeEnum.END_OF_CONTRACT, sortOrder: 7000 },
		{ type: TlswTodoTypeEnum.PARENT_SCOPE_CONSENT_SIGNED, title: 'Sign Scope of Work & Consent', group: TodoGroupEnum.PARENT, sortOrder: 8000 },
		{ type: TlswTodoTypeEnum.PARENT_DATA_POLICY_GIVEN, title: 'Give Data Protection, Retention, Deletion & Privacy Policy', group: TodoGroupEnum.PARENT, sortOrder: 9000 },
		{ type: TlswTodoTypeEnum.PARENT_DATA_POLICY_SIGNED, title: 'Sign Data Protection, Retention, Deletion & Privacy Policy', group: TodoGroupEnum.PARENT, sortOrder: 10000 },
		{ type: TlswTodoTypeEnum.PARENT_BIRTH_WORK_CONSENT_SIGNED, title: 'Sign Information Gathering Work Consent Form', group: TodoGroupEnum.PARENT, sortOrder: 11000 },

		{ type: TlswTodoTypeEnum.BASELINE_ASSESSMENT_INITIAL_COMPLETED, title: 'Complete Initial Assessment', group: TodoGroupEnum.BASELINE_ASSESSMENT, sortOrder: 12000 },
		{ type: TlswTodoTypeEnum.BASELINE_ASSESSMENT_INITIAL_UPLOADED, title: 'Upload Initial Assessment', group: TodoGroupEnum.BASELINE_ASSESSMENT, sortOrder: 13000 },
		{ type: TlswTodoTypeEnum.BASELINE_ASSESSMENT_FINAL_COMPLETED, title: 'Complete Final Assessment', group: TodoGroupEnum.BASELINE_ASSESSMENT, sortOrder: 14000, dueDateType: DueDateTypeEnum.END_OF_CONTRACT },
		{ type: TlswTodoTypeEnum.BASELINE_ASSESSMENT_FINAL_UPLOADED, title: 'Upload Final Assessment', group: TodoGroupEnum.BASELINE_ASSESSMENT, sortOrder: 15000, dueDateType: DueDateTypeEnum.END_OF_CONTRACT },

		{ type: TlswTodoTypeEnum.CODING_LOCATION_IDENTIFIED, title: 'Identify Location of Adoption Files', hasNote: true, noteTitle: 'Adoption Files Location details', sortOrder: 16000, group: TodoGroupEnum.CODING },
		{ type: TlswTodoTypeEnum.CODING_HOLDER_IDENTIFIED, title: 'Identify Holder of Files (if not with Adopters)', group: TodoGroupEnum.CODING, sortOrder: 17000 },
		{ type: TlswTodoTypeEnum.CODING_FILES_OBTAINED, title: 'Obtain Files and Chronologies', group: TodoGroupEnum.CODING, sortOrder: 18000 },
		{ type: TlswTodoTypeEnum.CODING_COMPLETED, title: 'Prepare Chronologies for Interviews', group: TodoGroupEnum.CODING, sortOrder: 19000 },

		{ type: TlswTodoTypeEnum.BIRTH_LETTERBOX_CONTACTED, title: 'Contact Letterbox Team', group: TodoGroupEnum.BIRTH, sortOrder: 20000 },

		{ type: TlswTodoTypeEnum.BIRTH1_IDENTIFIED, title: 'Identify Birth Family Member #1', sortOrder: 21000, hasNote: true, noteTitle: "Details of Birth Family Member No 1", group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH1_CONTACTED, title: 'Contact Birth Family Member #1', sortOrder: 22000, group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH1_VISIT_DATE_ARRANGED, title: 'Arrange Visit Date (#1)', sortOrder: 23000, hasNote: true, noteTitle: "Visit date for Birth Family Member No 1", group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH1_LOCATION_IDENTIFIED, title: 'Identify Visit Location (#1)', sortOrder: 24000, hasNote: true, noteTitle: "Visit Location for Birth Family Member No 1", group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH1_LOCATION_BOOKED, title: 'Book Visit Location (#1)', sortOrder: 25000, group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH1_VISIT_COMPLETED, title: 'Complete Visit (#1)', sortOrder: 26000, group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH1_TRANSCRIBED, title: 'Transcribe Interview (#1)', sortOrder: 27000, group: TodoGroupEnum.BIRTH },

		{ type: TlswTodoTypeEnum.BIRTH2_IDENTIFIED, title: 'Identify Birth Family Member #2', sortOrder: 28000, hasNote: true, noteTitle: "Details of Birth Family Member No 2", group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH2_CONTACTED, title: 'Contact Birth Family Member #2', sortOrder: 29000, group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH2_VISIT_DATE_ARRANGED, title: 'Arrange Visit Date (#2)', sortOrder: 30000, hasNote: true, noteTitle: "Visit date for Birth Family Member No 2", group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH2_LOCATION_IDENTIFIED, title: 'Identify Visit Location (#2)', sortOrder: 31000, hasNote: true, noteTitle: "Visit Location for Birth Family Member No 2", group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH2_LOCATION_BOOKED, title: 'Book Visit Location (#2)', sortOrder: 32000, group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH2_VISIT_COMPLETED, title: 'Complete Visit (#2)', sortOrder: 33000, group: TodoGroupEnum.BIRTH },
		{ type: TlswTodoTypeEnum.BIRTH2_TRANSCRIBED, title: 'Transcribe Interview (#2)', sortOrder: 34000, group: TodoGroupEnum.BIRTH },

		{ type: TlswTodoTypeEnum.TLSW_ALL_ABOUT_ME, title: 'Complete All About Me', group: TodoGroupEnum.TLSW, sortOrder: 35000 },
		{ type: TlswTodoTypeEnum.TLSW_DRAFT_COMPLETED, title: 'Complete Draft book', group: TodoGroupEnum.TLSW, sortOrder: 36000 },
		{ type: TlswTodoTypeEnum.TLSW_DRAFT_PRESENTED, title: 'Present Draft book', group: TodoGroupEnum.TLSW, sortOrder: 37000 },
		{ type: TlswTodoTypeEnum.TLSW_FINAL_COMPLETED, title: 'Complete Final book', group: TodoGroupEnum.TLSW, sortOrder: 38000, dueDateType: DueDateTypeEnum.END_OF_CONTRACT },
		{ type: TlswTodoTypeEnum.TLSW_FINAL_PRINTED, title: 'Print Final book', group: TodoGroupEnum.TLSW, sortOrder: 39000, dueDateType: DueDateTypeEnum.END_OF_CONTRACT },
		{ type: TlswTodoTypeEnum.TLSW_FINAL_LOADED, title: 'Load Final book Into Folder', group: TodoGroupEnum.TLSW, sortOrder: 40000, dueDateType: DueDateTypeEnum.END_OF_CONTRACT },
		{ type: TlswTodoTypeEnum.TLSW_BOOK_DELIVERED, title: 'Deliver book (With Paperwork)', group: TodoGroupEnum.TLSW, sortOrder: 41000, dueDateType: DueDateTypeEnum.END_OF_CONTRACT }
	]
};

const todoGroupToName = function(todoGroupEnum){
	switch (todoGroupEnum) {
		case TodoGroupEnum.ADMIN:
			return 'Admin';
		case TodoGroupEnum.PARENT:
			return 'Adoptive Parent / Carer Information & Forms';
		case TodoGroupEnum.BASELINE_ASSESSMENT:
			return 'Baseline Assessment';
		case TodoGroupEnum.CODING:
			return 'Information Bank Work';
		case TodoGroupEnum.BIRTH:
			return 'Information Gathering Work';
		case TodoGroupEnum.TLSW:
			return 'TLSW book';
		default:
			return 'Custom Tasks';

	}
}

function isBirthFamilyTodo(todoItem){
	return todoItem.group === TodoGroupEnum.BIRTH
		|| todoItem.group === TodoGroupEnum.CODING
}
function isBirthParent1(todoItem){
	return todoItem.type?.startsWith("BIRTH1_")
}
function isBirthParent2(todoItem){
	return todoItem.type?.startsWith("BIRTH2_")
}

export {
	TlswTodoTemplate,
	TlswTodoTypeEnum,
	TodoGroupEnum,
	todoGroupToName,
	isBirthFamilyTodo,
	isBirthParent1,
	isBirthParent2,
}
